<template>
  <div v-if="visible" class="wrapper" @touchmove.self.prevent>
    <div class="content">
      <div class="top">确认角色</div>
      <div class="mid">
        <div class="role_field">
          <div class="role_label">选择账号-区服-角色</div>
          <div class="role_select" @click.stop="toggleRoleDropdown">
            <span class="role_select_text">{{ selectedRoleText || '请选择角色' }}</span>
            <span class="role_select_arrow" :class="{ active: roleDropdownVisible }"></span>
          </div>
          <div
            v-if="roleDropdownVisible"
            class="role_dropdown"
            @touchmove.stop
          >
            <div
              v-for="item in roleOptions"
              :key="item.key"
              class="role_item"
              :class="{ active: selectedKey === item.key }"
              @click.stop="selectRole(item)"
            >
              {{ item.text }}
            </div>
            <div v-if="roleOptions.length === 0" class="empty_text">暂无可绑定角色</div>
          </div>
        </div>
      </div>
      <div class="footer">
        <div
          class="dialog_btn change_account"
          :class="{ disabled: submitLoading }"
          @click="onChangeAccount"
        >
          更换账号
        </div>
        <div
          class="dialog_btn submit"
          :class="{ disabled: submitLoading }"
          @click="onConfirm"
        >
          {{ submitLoading ? '绑定中...' : '确认绑定' }}
        </div>
      </div>
    </div>
    <!-- <img class="close" :src="closeImg" alt="" @click="close" /> -->
  </div>
</template>

<script>
import { CDN_URL } from '@/config/index.js';
import { Toast } from 'vant';
import { bindActivityLandingRole } from '@/api/activityLanding';
import {
  ACTIVITY_LANDING_BIND_RESULT,
  ACTIVITY_LANDING_BTN_TYPE,
  ACTIVITY_LANDING_POPUP_TYPE,
  reportActivityLandingData,
} from './report';

export default {
  name: 'ActivityLandingConfirmRoleDialog',
  data() {
    return {
      visible: false,
      submitLoading: false,
      hashId: '',
      userId: '',
      account: '',
      appKey: '',
      reportActId: '',
      reportActName: '',
      roleOptions: [],
      selectedKey: '',
      roleDropdownVisible: false,
      closeImg: `${CDN_URL}/imperialGlory/dialog-mid-close.png`,
    };
  },
  computed: {
    selectedRoleText() {
      const selected = this.roleOptions.find((item) => item.key === this.selectedKey);
      return selected ? selected.text : '';
    },
  },
  methods: {
    open(options = {}) {
      this.hashId = options.hash_id || '';
      this.userId = options.user_id || '';
      this.account = options.account || '';
      this.appKey = options.app_key || '';
      this.reportActId = options.act_id || '';
      this.reportActName = options.act_name || '';
      this.roleOptions = this.normalizeRoleList(options.role_list || []);
      this.selectedKey = this.roleOptions[0] ? this.roleOptions[0].key : '';
      this.roleDropdownVisible = false;
      this.visible = true;
      this.reportPopupShow();
      if (!this.roleOptions.length) {
        Toast.fail('暂无可绑定角色');
      }
    },
    close() {
      this.visible = false;
      this.roleDropdownVisible = false;
    },
    normalizeRoleList(list) {
      if (!Array.isArray(list)) return [];
      return list.map((item, index) => {
        const account = this.account || '';
        const serverId = item.server_id || '';
        const serverName = item.server_name || '';
        const roleId = item.role_id || '';
        const roleName = item.role_name || '';
        return {
          key: `${serverId}_${roleId}_${index}`,
          account,
          serverId,
          serverName,
          roleId,
          roleName,
          userId: item.user_id || this.userId || '',
          appKey: item.app_key || '',
          text: [account, serverName, roleName].filter(Boolean).join('-'),
        };
      });
    },
    selectRole(item = {}) {
      this.selectedKey = item.key || '';
      this.roleDropdownVisible = false;
    },
    // 参照 AccountSelectDialog 的自定义列表写法，展开/收起角色候选项。
    toggleRoleDropdown() {
      if (this.submitLoading) return;
      this.roleDropdownVisible = !this.roleDropdownVisible;
    },
    onChangeAccount() {
      if (this.submitLoading) return;
      this.close();
      this.$emit('change-account');
    },
    onConfirm() {
      const selected = this.roleOptions.find((item) => item.key === this.selectedKey);
      if (!selected) {
        Toast.fail('请选择角色');
        return;
      }
      if (!this.hashId) {
        Toast.fail('缺少承接页参数');
        return;
      }
      if (this.submitLoading) return;
      this.submitLoading = true;
      bindActivityLandingRole({
        hash_id: this.hashId,
        user_id: selected.userId || this.userId,
        account: selected.account || this.account,
        role_id: selected.roleId,
        server_id: selected.serverId,
        role_name: selected.roleName,
        server_name: selected.serverName,
        app_key: selected.appKey || this.appKey,
      })
        .then(async (res) => {
          const result = (res && res.data) || {};
          await this.reportConfirmBindResult(ACTIVITY_LANDING_BIND_RESULT.SUCCESS);
          Toast.success('绑定成功');
          // 角色绑定成功后也保留接口完整返回，交给承接页统一拼接跳转参数。
          this.$emit('confirm', {
            ...(res || {}),
            ...result,
            data: result,
            account: selected.account || this.account,
            user_id: selected.userId || this.userId,
            landing_bind_account: result.landing_bind_account || selected.account || this.account,
            landing_bind_user_id: result.landing_bind_user_id || selected.userId || this.userId,
            server_id: selected.serverId,
            server_name: selected.serverName,
            role_id: selected.roleId,
            role_name: selected.roleName,
            app_key: selected.appKey || this.appKey,
          });
          this.close();
        })
        .catch(() => {
          this.reportConfirmBindResult(ACTIVITY_LANDING_BIND_RESULT.FAIL);
        })
        .finally(() => {
          this.submitLoading = false;
        });
    },
    // data_type=2：确认角色弹窗展示上报。
    reportPopupShow() {
      return reportActivityLandingData({
        data_type: 2,
        hash_id: this.hashId,
        popup_type: ACTIVITY_LANDING_POPUP_TYPE.CONFIRM_ROLE,
      });
    },
    // data_type=5：确认角色弹窗内点击“确认绑定”的绑定结果上报。
    reportConfirmBindResult(bindResult) {
      return reportActivityLandingData({
        data_type: 5,
        hash_id: this.hashId,
        act_id: this.reportActId,
        act_name: this.reportActName,
        bind_result: bindResult,
        btn_type: ACTIVITY_LANDING_BTN_TYPE.CONFIRM_BIND,
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.wrapper {
  position: fixed;
  left: 0;
  top: 0;
  bottom: 0;
  right: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 110;
  .content {
    width: 312px;
    height: 236px;
    background: #ffffff;
    border-radius: 8px;
    overflow: hidden;
    margin: 0 auto;
    position: relative;
    .top {
      width: 100%;
      height: 38px;
      text-align: center;
      line-height: 38px;
      color: #fff;
      background: #fe4f4a;
      font-size: 17px;
      font-weight: 700;
    }
    .mid {
      width: 100%;
      padding: 0 20px;
      margin-top: 30px;
    }
    .role_field {
      display: flex;
      align-items: center;
      position: relative;
      min-height: 44px;
      border-bottom: 1px solid #ebedf0;
    }
    .role_label {
      flex: none;
      width: 128px;
      color: #646566;
      font-size: 14px;
      line-height: 24px;
      white-space: nowrap;
    }
    .role_select {
      flex: 1;
      min-width: 0;
      display: flex;
      align-items: center;
      justify-content: space-between;
      height: 32px;
      color: #323233;
      font-size: 14px;
    }
    .role_select_text {
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
    .role_select_arrow {
      flex: none;
      width: 0;
      height: 0;
      margin-left: 6px;
      border-top: 5px solid #999;
      border-right: 4px solid transparent;
      border-left: 4px solid transparent;
      transition: transform 0.2s ease;
      &.active {
        transform: rotate(180deg);
      }
    }
    .role_dropdown {
      position: absolute;
      z-index: 2;
      top: 44px;
      right: 0;
      left: 128px;
      max-height: 120px;
      overflow-y: auto;
      -webkit-overflow-scrolling: touch;
      overscroll-behavior: contain;
      border-radius: 4px;
      background: #fff;
      box-shadow: 0 4px 12px rgba(0, 0, 0, 0.12);
    }
    .role_item {
      padding: 10px 12px;
      border-bottom: 1px solid #eee;
      color: #333;
      font-size: 13px;
      line-height: 18px;
      text-align: left;
      word-break: break-all;
      &:active,
      &.active {
        color: #fe4f4a;
        background-color: #fff5f4;
      }
      &:last-child {
        border-bottom: none;
      }
    }
    .empty_text {
      padding: 14px 12px;
      color: #999;
      font-size: 13px;
      text-align: center;
    }
    .footer {
      display: flex;
      align-items: center;
      justify-content: center;
      gap: 22px;
      margin-top: 34px;
    }
    .dialog_btn {
      width: 121.5px;
      height: 39px;
      border-radius: 39px;
      line-height: 39px;
      text-align: center;
      font-family: Microsoft YaHei, Microsoft YaHei-Regular;
      font-weight: 400;
      font-size: 16px;
      box-sizing: border-box;
      &.disabled {
        opacity: 0.65;
      }
    }
    .change_account {
      color: #fe4f4a;
      background: #fff;
      border: 1px solid #fe4f4a;
    }
    .submit {
      color: #fff;
      background: #fe4f4a;
    }
  }
  .close {
    display: block;
    width: 26px;
    height: 26px;
    margin: 20px auto 0 auto;
  }
}
</style>
